(() => {
if (window.odAlterEgoLoaded) return;
window.odAlterEgoLoaded = true;
function tick() {
 document.querySelectorAll('[data-ae-countdown]').forEach(el => {
  const end = Date.parse(el.dataset.aeCountdown), clock = el.querySelector('[data-ae-clock]');
 if (!clock) return;
  if (!Number.isFinite(end)) { clock.textContent = ''; return; }
  const seconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
  const days = Math.floor(seconds / 86400), hours = Math.floor(seconds % 86400 / 3600);
  const minutes = Math.floor(seconds % 3600 / 60);
  const remainingSeconds = seconds % 60;
  const text = el.dataset.countdownFormat === 'compact'
    ? `${days}D ${hours}H ${minutes}M ${remainingSeconds}S`
    : `${days} DAYS ${hours} HOURS ${minutes} MIN ${remainingSeconds} SEC`;
  clock.textContent = seconds ? text : (el.dataset.expired || '');
 });
}
tick(); setInterval(tick,1000); document.addEventListener('shopify:section:load',tick);
})();
